import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link, LinkProps, styled } from '@mui/material';
import { ApiHourlyData } from '@/components/_common/Table/Calendar/CalendarComponents/types';
import { replaceQueryParams } from '@/_utils/routes';

interface Props {
  date: string; // date in a CALENDAR_START_DATE_FORMAT format
  limit: number;
  totalCount: number | undefined;
  avails: ApiHourlyData[];
  children(avail: ApiHourlyData): React.ReactNode; // function that renders single avail
}

const ShowMore: React.FC<Props> = ({ date, limit, totalCount, avails, children }) => {
  const dailyViewURL = replaceQueryParams({ calendarStartDate: date, calendarView: 'day' });
  const total = totalCount !== undefined ? totalCount : avails.length;

  return (
    <>
      {avails.slice(0, limit).map(children)}
      {total > limit && (
        <StyledLink component={RouterLink} to={dailyViewURL}>
          {(total - limit).toLocaleString()} more...
        </StyledLink>
      )}
    </>
  );
};

export default ShowMore;

const StyledLink = styled(Link)<LinkProps<typeof RouterLink>>`
  font-weight: 600;
  font-size: 0.857em;
  color: ${({ theme }) => (theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.primary.dark)};
`;
